import React from 'react';
import { useLocation } from 'react-router-dom';
import { editClient } from '../../api';
import _ from 'lodash';
import { PaymentResultContainer } from '../onboarding/setup/payment';

// Main Payment Page component
export default function PaymentResult({ logOut, history }) {
	const location = useLocation();
	const path = location.pathname;
    const {type} = location.state || {};

    const updateClient = async () => {
        const user = JSON.parse(localStorage.getItem('phs-user'))
        const params = JSON.parse(localStorage.getItem('selectedMembership'))
        if (!user || !params) return;
        await editClient(params, user.id, '?client_select_membership=true')
        _.assign(user.profile, params.profile)
    }

    if (path.includes('/success')) {
        updateClient();
		return <PaymentResultContainer status="success" history={history} logOut={logOut} type={type} />;
	}

    if (path.endsWith('/cancel')) {
        return <PaymentResultContainer status="failure" history={history} logOut={logOut} />;
    }
	// TODO: Replace with actual payment form UI
	return <div>Payment Form Goes Here</div>;
}